export const REDIRECT_NAME = 'Redirect';

export const PARENT_LAYOUT_NAME = 'ParentLayout';

export const PAGE_NOT_FOUND_NAME = 'PageNotFound';

// FIXME: 异常页面的补齐
export const EXCEPTION_COMPONENT = () => import('@/views/sys/exception/Exception.vue');

export const FORBIDDEN_COMPONENT = () => import('@/views/sys/exception/403.vue');

/**
 * @description: default layout
 */
export const LAYOUT = () => import('@/layouts/default/index.vue');

export const BLANK = () => import('@/layouts/default/blank.vue');

/**
 * @description: parent-layout
 */
export const getParentLayout = (_name?: string) => {
  return () =>
    new Promise((resolve) => {
      resolve({
        name: _name || PARENT_LAYOUT_NAME
      });
    });
};
